import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import { randomPassword } from '@/utils/vuex';
export default {
  name: 'ViewAccountMgmtAccountMgmtUserBulkCreate',
  data: function data() {
    return {
      tenantDetails: null,
      userDataCsv: '',
      faultyUserDataCsv: '',
      userCreateProgress: 0,
      scope: null,
      password: this.randomPassword,
      access: [],
      loading: false,
      valid: false,
      originalUser: null,
      defaultPasswordPolicy: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'inpOutlined', 'inpFilled', 'color', 'UiTheme'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    passwordRules: function passwordRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED');
      }, function (v) {
        return v.length >= _this2.defaultPasswordPolicy.length || _this2.$i18n_tc('accMgmt.user.passwordErrors.USER_PASSWORD_MINLENGTH', _this2.defaultPasswordPolicy.length, {
          n: _this2.defaultPasswordPolicy.length
        });
      }];
    },
    csvRules: function csvRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$i18n_t('Common.fieldRequired');
      }, function (v) {
        var emailAdresses = [];
        var userData = v.split(/\n/g);

        var _loop = function _loop(i) {
          var userDatum = userData[i].split(';');

          if (userDatum.length < 3) {
            if (userData[i].trim() !== '') {
              return {
                v: _this3.$i18n_t('accMgmt.user.requiredCsvFields')
              };
            }
          }

          if (userDatum.length >= 3) {
            if (emailAdresses.find(function (email) {
              return email.toLowerCase() === userDatum[2].toLowerCase();
            })) {
              return {
                v: _this3.$i18n_t('accMgmt.user.duplicateEmailsInCsv') + userDatum[2]
              };
            }

            if (!/.+@.+\..+/.test(userDatum[2])) {
              return {
                v: "".concat(_this3.$i18n_t('Common.emailValid'), " ").concat(userDatum[2])
              };
            }

            emailAdresses.push(userDatum[2]);

            if (userDatum.length >= 4) {
              var userPropertyJson = null;

              try {
                // do not use the userDatum[3], in case the JSON contains any semicolons
                var replace = [userDatum[0], userDatum[1], userDatum[2], ''].join(';');
                var jsonString = userData[i].replace(replace, '');
                userPropertyJson = JSON.parse(jsonString);
              } catch (error) {// on error we return outside of try/catch
              }

              if (!userPropertyJson) {
                return {
                  v: _this3.$i18n_t('accMgmt.user.invalidCsvJson') + userDatum[3]
                };
              }
            }
          }
        };

        for (var i = 0; i < userData.length; i++) {
          var _ret = _loop(i);

          if (_typeof(_ret) === "object") return _ret.v;
        }

        return true;
      }];
    }
  }),
  watch: {},
  mounted: function mounted() {
    this.checkAccess();
    this.password = randomPassword();
  },
  methods: {
    cancelUserEdit: function cancelUserEdit() {
      this.$router.push({
        path: "/account-mgmt/".concat(this.$route.params.tenantId, "?userlist")
      });
    },
    checkAccess: function checkAccess() {
      return this.fetchTenantData();
    },
    didSelectScope: function didSelectScope(scope) {
      this.scope = scope;
      this.fetchDefaultRoles(scope.id);
    },
    fetchDefaultRoles: function fetchDefaultRoles(scopeId) {
      var _this4 = this;

      ApiService.fetchDefaultRoles(scopeId).then(function (roles) {
        if (roles.length > 0) {
          _this4.access = [{
            tenantId: roles[0].tenantId,
            scopeId: scopeId,
            Scope: {
              id: scopeId
            },
            roles: roles,
            primary: true
          }];
        }
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
      });
    },
    fetchTenantData: function fetchTenantData() {
      var _this5 = this;

      return Promise.all([ApiService.tenantGetPasswordPolicy(), // NOTE: using `no-descendents` to not get any child-data; this will ALSO _NOT_ load any scope-descendents
      ApiService.tenantGetById(this.$route.params.tenantId, ['no-descendents'])]).then(function (data) {
        _this5.defaultPasswordPolicy = data[0];
        var tenant = data[1];
        _this5.tenantDetails = tenant;
        return tenant;
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack('Failed to fetch tenant', 'error');
        }

        _this5.$router.push({
          path: "/account-mgmt/".concat(_this5.$route.params.tenantId, "?userlist")
        });
      });
    },
    validate: function validate() {
      this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.snackbar = true;
      }
    },
    handleSubmit: function handleSubmit() {
      this.validate();

      if (this.valid) {
        this.parseCsv();
      }
    },
    parseCsv: function () {
      var _parseCsv = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var userData, userInfos, faultyUsers, i, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userData = this.userDataCsv.split(/\n/g);
                userInfos = [];
                userData.forEach(function (data) {
                  var userDatum = data.split(';');

                  if (userDatum.length >= 3) {
                    var userPropertyKeyValue = [];

                    if (userDatum.length >= 4) {
                      try {
                        // do not use the userDatum[3], in case the JSON contains any semicolons
                        var replace = [userDatum[0], userDatum[1], userDatum[2], ''].join(';');
                        var jsonString = data.replace(replace, '');
                        var userPropertyJson = JSON.parse(jsonString);

                        if (userPropertyJson) {
                          Object.keys(userPropertyJson).forEach(function (key) {
                            userPropertyKeyValue.push({
                              key: key,
                              value: userPropertyJson[key]
                            });
                          });
                        }
                      } catch (error) {// ignore error
                      }
                    }

                    var user = {
                      firstName: userDatum[0],
                      lastName: userDatum[1],
                      email: userDatum[2],
                      username: userDatum[2],
                      active: true,
                      properties: {
                        values: userPropertyKeyValue
                      },
                      access: _this6.access,
                      scope: _this6.scope,
                      password: _this6.password
                    };
                    userInfos.push(user);
                  }
                });
                this.userCreateProgress = 1;
                faultyUsers = [];
                i = 0;

              case 6:
                if (!(i < userInfos.length)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 9;
                return this.createUser(userInfos[i]);

              case 9:
                result = _context.sent;

                if (result) {
                  faultyUsers.push(userData[i]);
                } else {
                  this.userCreateProgress = parseFloat(i + 1) / parseFloat(userInfos.length) * 100;
                  this.$snack(this.$i18n_t('accMgmt.user.bulkCreateUserSuccessSnack', {
                    i: i + 1,
                    count: userInfos.length
                  }), 'success');
                }

              case 11:
                i++;
                _context.next = 6;
                break;

              case 14:
                this.faultyUserDataCsv = faultyUsers.join('\n');

                if (faultyUsers.length === 0) {
                  this.$router.push({
                    path: "/account-mgmt/".concat(this.$route.params.tenantId, "?userlist")
                  });
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function parseCsv() {
        return _parseCsv.apply(this, arguments);
      }

      return parseCsv;
    }(),
    createUser: function createUser(user) {
      var _this7 = this;

      return ApiService.createUser(this.$route.params.tenantId, user).then(function () {
        return null;
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack(_this7.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
        }

        return error;
      });
    },
    updatedUserAccess: function updatedUserAccess(access) {
      this.access = access;

      if ((access || []).length === 0) {
        this.scope = null;
      }
    }
  }
};